import { useEffect, useState } from "react";
import {
  SmartAlert,
  SmartLoaderInterface,
  SmartTable,
  SmartTableNewInterface,
} from "soft_digi";
import { useSiteContext } from "../../contexts/SiteProvider";
import { showAlertAutoClose } from "../../services/notifyService";
import { get, post } from "../../services/smartApiService";
import SalaryComponentsForm from "./SalaryComponentsForm";
import { SALARY_COMPONENT_URLS } from "../../api/SettingsUrls";

const SalaryComponentsTable = () => {
  const [tabData, setTabData] = useState([]);
  const { openModal, closeModal } = useSiteContext();

  const loadTableData = () => {
    let URL = SALARY_COMPONENT_URLS.GET_ALL;
    const subscription = get(URL).subscribe((response) => {
      setTabData(response.data);
    });
    return () => {
      subscription.unsubscribe();
    };
  };

  useEffect(() => {
    loadTableData();
  }, []);

  const openOfficesForm = (data: any) => {
    let options = {
      title: (
        <>
          {data.ID
            ? "Salary Components Update Form"
            : "Salary Components Addition Form"}
        </>
      ),
      content: (
        <SalaryComponentsForm loadTableData={loadTableData} data={data} />
      ),
      className: "sd-efl-modal",
      closeBody: false,
      width: 60,
    };
    openModal(options);
  };

  const deleteData = (id: any) => {
    const subscription = post(SALARY_COMPONENT_URLS.DELETE, {
      id: id,
    }).subscribe((response) => {
      showAlertAutoClose("Deleted Successfully...", "success");
      closeModal();
      loadTableData();
      // setLoading(false);
    });
    return () => {
      subscription.unsubscribe();
    };
  };

  const openDeleteModal = (id: any) => {
    let alertProps: SmartLoaderInterface.SmartAlertInterface = {
      title: (
        <span className="has-text-danger">
          <i className="fa fa-check"></i> Salary Components Deletion!
        </span>
      ),
      alertFunction: (option) => {
        if (option == "yes") {
          deleteData(id);
          SmartAlert.hide();
        }
      },
      content: (
        <p>
          Note: Do you wish to delete this Salary Components? This action cannot
          be reverted
        </p>
      ),
      className: "custom-alert",
    };

    SmartAlert.show(alertProps);
  };

  const viewEditForm = (id: any) => {
    const subscription = post(SALARY_COMPONENT_URLS.GET_ONE, {
      id: id,
    }).subscribe((response: any) => {
      openOfficesForm(response.data);
    });
    return () => {
      subscription.unsubscribe();
    };
  };

  const openViewDetails = (userData: any) => {
    let options = {
      title: "User Details",
      //   content: <UsersTableView userData={userData} />,
      width: 60,
      className: "sd-efl-modal",
      closeBody: false,
    };
    openModal(options);
  };

  const buttons = [
    // {
    //   label: "",
    //   type: "icon",
    //   leftIcon: "fa fa-eye",
    //   classList: ["smart-hims-table-view-icon"],
    //   onClick: (data: any) => {
    //     // openViewDetails(data);
    //   },
    // },
    {
      label: "",
      type: "icon",
      leftIcon: " fa-pencil-square",
      classList: ["smart-hims-table-edit-icon"],
      onClick: (data: any) => {
        viewEditForm(data["ID"]);
      },
    },
    {
      label: "",
      type: "icon",
      leftIcon: "fa fa-trash",
      classList: ["smart-hims-table-delete-icon"],
      onClick: (data: any) => {
        openDeleteModal(data["ID"]);
      },
    },
  ];

  const columns: SmartTableNewInterface.SmartTableNewColumnConfig[] = [
    { title: "S.NO", index: "s_no", type: "sno", width: "5" },
    {
      title: "Name",
      index: "component_name",
      width: "10",
    },
    {
      title: "Type",
      index: "component_type",
      width: "15",
    },
    {
      title: "Calculation type",
      index: "calculation_type",
      width: "10",
    },
    {
      title: "Default  Amount",
      index: "default_amount",
      width: "10",
      type: "currency",
    },

    {
      title: "Action",
      index: "action",
      type: "buttons",
      buttons: buttons,
      width: "10",
    },
  ];
  const tableTop: SmartTableNewInterface.SmartTableNewTopProps[] = [
    {
      type: "CUSTOM",
      widthClass: "is-6",
      custom: (
        <p className="is-size-4 has-text-weight-bold">Salary Components</p>
      ),
    },
    {
      type: "SEARCH",
      widthClass: "is-4",
      align: "JUSTIFY",
    },
    {
      type: "BUTTONS",
      widthClass: "is-2",
      align: "CENTER",
      buttons: [
        {
          type: "REFRESH",
          action: loadTableData,
        },
        {
          label: "Add",
          icon: "fa-plus",
          type: "CUSTOM",
          className: "smart-third-button",
          action: openOfficesForm,
        },
      ],
    },
  ];

  return (
    <>
      <div className="sd-efl-input">
        <SmartTable
          columns={columns}
          data={tabData}
          tableTop={tableTop}
          tableProps={{
            className: "is-hoverable is-bordered smart-hims-table",
            isResponsive: true,
            searchPlaceHolder: "Search",
          }}
          paginationProps={{
            pageSize: 10,
          }}
        />
      </div>
    </>
  );
};

export default SalaryComponentsTable;
